import { ServerStatus } from '@/services/Server';

export interface ServerConfigInterface {
  ips?: string[];
  dns_ip?: string;
}

export interface ServerInterface {
  _id: string;
  hostname: string;
  status: ServerStatus;
  type: string;
  services: string[];
  config?: ServerConfigInterface;
}

export interface ApiAddServer {
  hostname: string;
  type: string;
  services: string[];
  config: ServerConfigInterface;
}

export class ApiServerTypeServicesAdd {
  public services: string[];
}

export interface UpdateServer {
  hostname: string;
  status: string;
  type: string;
  services: string[];
  config: ServerConfigInterface;
}

export enum ServerType {
  ORIGIN  = 'OriginServer',
  CDN  = 'CDNServer',
}

export interface ServerRepositoryInterface {
  getAllServers(): Promise<ServerInterface[]>;

  getServersOfType(type: string): Promise<ServerInterface[]>;

  getServerTypes(): Promise<string[]>;

  addServerTypeServices(type: string, servicesDto: ApiServerTypeServicesAdd): Promise<string[]>;

  getServerTypeServices(type: string): Promise<string[]>;

  getServersByIds(ids: string[]): Promise<ServerInterface[]>;

  addServer(addServerDto: ApiAddServer): Promise<void>;

  removeServer(hostname: string): Promise<void>;

  getServer(id: string): Promise<ServerInterface>;

  updateServerStatus(hostname: string, status: string): Promise<void>;
}
